<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M12.5002 22.9163C18.2531 22.9163 22.9168 18.2526 22.9168 12.4997C22.9168 6.74671 18.2531 2.08301 12.5002 2.08301C6.7472 2.08301 2.0835 6.74671 2.0835 12.4997C2.0835 18.2526 6.7472 22.9163 12.5002 22.9163Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 16.6667V12.5"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 8.33301H12.5104"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
